export default __webpack_public_path__ + "static/media/left-hand-saying-ok.a5fe2cdc.png";